import {
  CREATE_SNACKBAR,
  DELETE_SNACKBAR,
  SnackbarsState,
} from '../types/snackbars';
import { SnackbarActions } from '../actions/snackbars';

const initialState: SnackbarsState = [];

export default function SnackbarsReducer(
  state = initialState,
  action: SnackbarActions,
): SnackbarsState {
  switch (action.type) {
    case CREATE_SNACKBAR: {
      const item = {
        ...action.payload,
        id: Date.now(),
      };

      return [...state, item];
    }

    case DELETE_SNACKBAR: {
      return state.filter(item => item.id !== action.payload);
    }

    default: {
      return state;
    }
  }
}
